import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import {
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  getProgressionLastElement4s9ggap3esy2 as getProgressionLastElement_0,
} from '../internal/progressionUtil.mjs';
import {
  IntProgressionIterator2ovd1ctrmu51n as IntProgressionIterator,
  LongProgressionIterator2e3slqmdh4zt7 as LongProgressionIterator,
  CharProgressionIterator34nq4ujuknl08 as CharProgressionIterator,
} from './ProgressionIterators.mjs';
import { Iterable1y3qizuf89iou as Iterable } from '../collections/Collections.mjs';
import {
  numberToLong2pakxeg38estk as numberToLong,
  shiftRightUnsigned1ga7wnvbv2qur as shiftRightUnsigned,
  multiply2k9eolhnz1bjv as multiply,
  add2suhfggl4zvkk as add,
  convertToInty04h231mmjoh as convertToInt,
  negate13xrbakfwasjy as negate,
} from '../js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  Char__toInt_impl_vasixd1agw9q2fuvclj as Char__toInt_impl_vasixd,
  Char__compareTo_impl_ypi4mbdrkik40uwhqc as Char__compareTo_impl_ypi4mb,
  toString3o7ifthqydp6e as toString,
} from '../Char.mjs';
import { numberToChar93r9buh19yek as numberToChar } from '../js/numberConversion.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      h2(rangeStart, rangeEnd, step) {
        return new (IntProgression())(rangeStart, rangeEnd, step);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var IntProgressionClass;
function IntProgression() {
  if (IntProgressionClass === VOID) {
    class $ {
      constructor(start, endInclusive, step) {
        if (step === 0)
          throw IllegalArgumentException().a1('Step must be non-zero.');
        if (step === -2147483648)
          throw IllegalArgumentException().a1('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
        this.i2_1 = start;
        this.j2_1 = getProgressionLastElement(start, endInclusive, step);
        this.k2_1 = step;
      }
      m1() {
        return new (IntProgressionIterator())(this.i2_1, this.j2_1, this.k2_1);
      }
      i1() {
        return this.k2_1 > 0 ? this.i2_1 > this.j2_1 : this.i2_1 < this.j2_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof IntProgression()) {
          tmp = this.i1() && other.i1() || (this.i2_1 === other.i2_1 && this.j2_1 === other.j2_1 && this.k2_1 === other.k2_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.i1() ? -1 : imul(31, imul(31, this.i2_1) + this.j2_1 | 0) + this.k2_1 | 0;
      }
      toString() {
        return this.k2_1 > 0 ? '' + this.i2_1 + '..' + this.j2_1 + ' step ' + this.k2_1 : '' + this.i2_1 + ' downTo ' + this.j2_1 + ' step ' + (-this.k2_1 | 0);
      }
    }
    initMetadataForClass($, 'IntProgression', VOID, VOID, [Iterable()]);
    IntProgressionClass = $;
  }
  return IntProgressionClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var LongProgressionClass;
function LongProgression() {
  if (LongProgressionClass === VOID) {
    class $ {
      constructor(start, endInclusive, step) {
        if (step === 0n)
          throw IllegalArgumentException().a1('Step must be non-zero.');
        if (step === -9223372036854775808n)
          throw IllegalArgumentException().a1('Step must be greater than Long.MIN_VALUE to avoid overflow on negation.');
        this.rr_1 = start;
        this.sr_1 = getProgressionLastElement_0(start, endInclusive, step);
        this.tr_1 = step;
      }
      m1() {
        return new (LongProgressionIterator())(this.rr_1, this.sr_1, this.tr_1);
      }
      i1() {
        return this.tr_1 > 0n ? this.rr_1 > this.sr_1 : this.rr_1 < this.sr_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof LongProgression()) {
          tmp = this.i1() && other.i1() || (this.rr_1 === other.rr_1 && this.sr_1 === other.sr_1 && this.tr_1 === other.tr_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.i1() ? -1 : convertToInt(add(multiply(numberToLong(31), add(multiply(numberToLong(31), this.rr_1 ^ shiftRightUnsigned(this.rr_1, 32)), this.sr_1 ^ shiftRightUnsigned(this.sr_1, 32))), this.tr_1 ^ shiftRightUnsigned(this.tr_1, 32)));
      }
      toString() {
        return this.tr_1 > 0n ? this.rr_1.toString() + '..' + this.sr_1.toString() + ' step ' + this.tr_1.toString() : this.rr_1.toString() + ' downTo ' + this.sr_1.toString() + ' step ' + negate(this.tr_1).toString();
      }
    }
    initMetadataForClass($, 'LongProgression', VOID, VOID, [Iterable()]);
    LongProgressionClass = $;
  }
  return LongProgressionClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var CharProgressionClass;
function CharProgression() {
  if (CharProgressionClass === VOID) {
    class $ {
      constructor(start, endInclusive, step) {
        if (step === 0)
          throw IllegalArgumentException().a1('Step must be non-zero.');
        if (step === -2147483648)
          throw IllegalArgumentException().a1('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
        this.as_1 = start;
        var tmp = this;
        // Inline function 'kotlin.code' call
        var tmp_0 = Char__toInt_impl_vasixd(start);
        // Inline function 'kotlin.code' call
        var tmp$ret$1 = Char__toInt_impl_vasixd(endInclusive);
        tmp.bs_1 = numberToChar(getProgressionLastElement(tmp_0, tmp$ret$1, step));
        this.cs_1 = step;
      }
      m1() {
        return new (CharProgressionIterator())(this.as_1, this.bs_1, this.cs_1);
      }
      i1() {
        return this.cs_1 > 0 ? Char__compareTo_impl_ypi4mb(this.as_1, this.bs_1) > 0 : Char__compareTo_impl_ypi4mb(this.as_1, this.bs_1) < 0;
      }
      equals(other) {
        var tmp;
        if (other instanceof CharProgression()) {
          tmp = this.i1() && other.i1() || (this.as_1 === other.as_1 && this.bs_1 === other.bs_1 && this.cs_1 === other.cs_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        var tmp;
        if (this.i1()) {
          tmp = -1;
        } else {
          // Inline function 'kotlin.code' call
          var this_0 = this.as_1;
          var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
          var tmp_0 = imul(31, tmp$ret$0);
          // Inline function 'kotlin.code' call
          var this_1 = this.bs_1;
          var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
          tmp = imul(31, tmp_0 + tmp$ret$1 | 0) + this.cs_1 | 0;
        }
        return tmp;
      }
      toString() {
        return this.cs_1 > 0 ? toString(this.as_1) + '..' + toString(this.bs_1) + ' step ' + this.cs_1 : toString(this.as_1) + ' downTo ' + toString(this.bs_1) + ' step ' + (-this.cs_1 | 0);
      }
    }
    initMetadataForClass($, 'CharProgression', VOID, VOID, [Iterable()]);
    CharProgressionClass = $;
  }
  return CharProgressionClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance2r6wsk1n1bbyk,
  CharProgression as CharProgression45cqq4g7w3uj,
  IntProgression as IntProgressionfaq59u1bhfih,
  LongProgression as LongProgression4dpjnpwadpbx,
};
//endregion

//# sourceMappingURL=Progressions.mjs.map
